import React from 'react';
import {
  Form,
  Input,
  Radio,
  Select,
  DatePicker,
  Button,
  Typography,
  Row,
  Col,
  Space,
} from 'antd';

const { Title, Text, Link } = Typography;
const { Option } = Select;

const OutOnWorkForm = () => {
  const [form] = Form.useForm();

  return (
    <Form form={form} layout="vertical">
      <div className='mt-6'>

        <p className='mb-2'>  <b>Out-on-work request</b> by Shreya Modi, UI & UX Designer, Noida - HO(DJTCO0181) on <b>18-Jun-2025, 12:33 pm</b></p>
               <p className='mt-0'> <b>Approval By</b> Durgesh Kumar Pandey, Assistant Vice President, Noida - HO(DJTCO0055) </p>

      </div>
        <br />
        <div className=''>


 
    <div className='flex'>
         <label className='font-bold mr-3 w-28 '>For Date</label>
      <Form.Item className='self-center'>
        <Space className="w-[11rem]"style={{ display:'block'}}>
          
          <DatePicker style={{width:'100%'}} placeholder="Select Date" />
           
        </Space>
      </Form.Item>
    <p className='ml-3 self-start mt-1 primary font-semibold'>(or select multiple dates)</p>
     
      </div>

      <div className='flex mt-3'>
       <label className='font-bold  mr-3 w-28'>Nature of work</label>
        <Form.Item >
        <Space className='w-[11rem]'>
          
          <Input placeholder="Select Date" />
        
        </Space>
      </Form.Item>

      
        <Form.Item className='ml-3'>
        <Radio.Group>
          <Space direction="vertical">
           <div className='w-[16rem] font-bold text-xs'> <Radio value="allDay "><span style={{fontSize:'12px'}}>I will be out on work all the time</span></Radio></div>

            <Radio value="late">
              <Row gutter={8} align="middle">
                <Col className='w-[14rem] font-bold text-xs '> I will be in late by:</Col>
                <Col>
                  <b className='text-xs'>HH:</b><Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(12)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
                    
                <Col>
                <b className='text-xs'>MM:</b>
                  <Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(60)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Radio.Group defaultValue="AM">
                    <Radio value="AM">AM</Radio>
                    <Radio value="PM">PM</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Radio>

            <Radio value="early">
              <Row gutter={8} align="middle">
                <Col  className='w-[14rem] font-bold text-xs'>I will be out early by:</Col>
                <Col>
                  <b className='text-xs'>HH:</b><Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(12)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
               
                <Col>
                <b className='text-xs'>MM:</b>
                  <Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(60)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Radio.Group defaultValue="AM">
                    <Radio value="AM">AM</Radio>
                    <Radio value="PM">PM</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Radio>

            <Radio value="lateAndEarly">
              <Row gutter={8} align="middle">
                <Col className='w-[14rem] font-bold text-xs'>I will be in late and out early by:</Col>
                <Col>
                  <b className='text-xs'>HH:</b><Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(12)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
             
                <Col>
                  <b className='text-xs'>MM:</b>
                  <Select size='small' defaultValue="09" style={{ width: 60 }}>
                    {[...Array(60)].map((_, i) => (
                      <Option key={i} value={String(i).padStart(2, '0')}>
                        {String(i).padStart(2, '0')}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Radio.Group size='small' defaultValue="AM">
                    <Radio value="AM">AM</Radio>
                    <Radio value="PM">PM</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      </div>

      
        </div>
        <Form.Item  name="reason">
                <label className='font-bold  mr-3 w-28'>Reason</label>
        <Input.TextArea rows={2} placeholder="Enter your reason" />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button className='px-4  py-1' type="primary" size="medium"  htmlType="submit">
            Submit
          </Button>
          <Button  className='px-4  py-1' size="medium" htmlType="button">Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default OutOnWorkForm;
